<template>
    <header id="header" :class="['header', {'has-top-panel': top_panel, 'has-sale-banner': showSaleBanner, 'header_folded': slideUp}]">
        <div v-if="showSaleBanner"
             class="header__sale-banner foldable"
             :class="{ 'header__sale-banner_folded': slideUpBanner }">
            <picture>
                <source media="(max-width: 480px)" :srcset="'/img/big-sale-ru-m.webp'" width="1440" height="404">
                <img :src="'/img/big-sale-ru.webp'" alt="Big Sale" width="2560" height="316"
                     @load="updateHeaderOffset">
            </picture>
        </div>
        <div v-if="top_panel" class="header__top foldable top-panel" v-html="top_panel"></div>
        <MobilMenu :menus ref="mob"/>
        <div class="header__center container foldable" :class="slideUp?'header__center_folded':''">
            <nav class="header__center-nav">
                <div class="header__burger" @click="$refs.mob.burgerMenu = !$refs.mob.burgerMenu">
                    <svg class="svg-icon svg" width="24" height="25" viewBox="0 0 24 25" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.75 12.0635H20.25" stroke="black" stroke-linecap="round"
                              stroke-linejoin="round"></path>
                        <path d="M3.75 6.06348H20.25" stroke="black" stroke-linecap="round"
                              stroke-linejoin="round"></path>
                        <path d="M3.75 18.0635H20.25" stroke="black" stroke-linecap="round"
                              stroke-linejoin="round"></path>
                    </svg>
                </div>
                <ul class="list center-nav-list">
                    <li class="list__element center-nav-list__element  ">
                        <a class="center-nav-list__link" :href="maleCatalogPath"
                           :class="gender === 'male' ? 'router-link-active':''"> {{ trans('Male') }} </a>
                    </li>
                    <li class="list__element center-nav-list__element ">
                        <a class="center-nav-list__link" :href="femaleCatalogPath"
                           :class="gender === 'female' ? 'router-link-active':''"> {{ trans('Female') }} </a>
                    </li>
                    <template v-if="isTopMenuView">
                        <li class="list__element center-nav-list__element " v-if="this.$store.state.settings.site_id == 1">
                            <a class="center-nav-list__link" href="/stores"> {{ trans('Stores') }} </a>
                        </li>
                        <li class="list__element center-nav-list__element ">
                            <a class="center-nav-list__link" href="/about"> {{ trans('About the brand') }} </a>
                        </li>
                        <li v-if="showSecretLink()" class="list__element center-nav-list__element ">
                            <a class="center-nav-list__link" href="/secret">{{trans('Secret')}}</a>
                        </li>
                    </template>
                </ul>
            </nav>

            <a href="/" class="header__logo">
                <img class="header__logo-img" :src="'/img/svg/logo.svg'" alt=""></a>
            <div class="header__control-row">
                <div v-if="this.$store.state.settings.site_id === 2 || this.$store.state.settings.user?.role_id > 500"
                     class="v-popper v-popper--theme-tooltip">
                    <div class="select-region__">
                        <a href="#" class="header__icon header__icon__panel "
                           v-on:click="visible_country=!visible_country">
                            <svg class="svg-icon" width="25" height="25" viewBox="0 0 16 16" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <circle cx="8" cy="8" r="7.25" stroke="#000" stroke-width="0.6"></circle>
                                <path
                                    d="M8 15.25C7.7649 15.25 7.48181 15.1442 7.15894 14.8321C6.83246 14.5165 6.50419 14.0235 6.21224 13.3562C5.62932 12.0239 5.25 10.1307 5.25 8C5.25 5.86928 5.62932 3.97615 6.21224 2.64376C6.50419 1.97645 6.83246 1.48352 7.15894 1.16789C7.48181 0.855751 7.7649 0.75 8 0.75C8.2351 0.75 8.51819 0.855751 8.84106 1.16789C9.16754 1.48352 9.49581 1.97645 9.78776 2.64376C10.3707 3.97615 10.75 5.86928 10.75 8C10.75 10.1307 10.3707 12.0239 9.78776 13.3562C9.49581 14.0235 9.16754 14.5165 8.84106 14.8321C8.51819 15.1442 8.2351 15.25 8 15.25Z"
                                    stroke="#000" stroke-width="0.6"></path>
                                <line x1="1" y1="5.75" x2="15" y2="5.75" stroke="#000" stroke-width="0.6"></line>
                                <line x1="1" y1="10.25" x2="15" y2="10.25" stroke="#000" stroke-width="0.6"></line>
                            </svg>
                        </a>
                        <div class="select-region-js " v-show="visible_country">
                            <Globe/>
                        </div>
                    </div>
                </div>
                <div class="v-popper v-popper--theme-tooltip">
                    <a href="/personal/favourites" class="header__icon">
                        <svg class="svg-icon" width="19" height="16" viewBox="0 0 19 16" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.94194 14.5533L16.2726 8.22267C17.8281 6.66717 18.0576 4.10814 16.5855 2.47343C16.2168 2.06277 15.7683 1.73155 15.2673 1.49997C14.7664 1.26839 14.2235 1.1413 13.6718 1.12647C13.1201 1.11163 12.5712 1.20936 12.0585 1.41368C11.5458 1.618 11.0801 1.92464 10.6899 2.31488L9.5 3.50476L8.47267 2.47742C6.91717 0.921917 4.35814 0.692428 2.72343 2.16446C2.31277 2.53318 1.98155 2.9817 1.74997 3.48266C1.51839 3.98362 1.3913 4.52651 1.37647 5.0782C1.36163 5.6299 1.45936 6.17883 1.66368 6.69151C1.868 7.20419 2.17464 7.66987 2.56488 8.06012L9.05806 14.5533C9.17527 14.6705 9.33424 14.7364 9.5 14.7364C9.66576 14.7364 9.82473 14.6705 9.94194 14.5533V14.5533Z"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                        <div class="header-icon__num favourites-count">{{ favourites }}</div>
                    </a>
                </div>
                <div class="v-popper v-popper--theme-tooltip">
                    <a href="/personal" class="header__icon">
                        <svg class="svg-icon" width="21" height="20" viewBox="0 0 21 20" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10.5 12.5C13.2614 12.5 15.5 10.2614 15.5 7.5C15.5 4.73858 13.2614 2.5 10.5 2.5C7.73858 2.5 5.5 4.73858 5.5 7.5C5.5 10.2614 7.73858 12.5 10.5 12.5Z"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path
                                d="M2.9209 16.8743C3.6893 15.5442 4.79419 14.4398 6.12456 13.672C7.45493 12.9042 8.96393 12.5 10.5 12.5C12.036 12.5 13.545 12.9043 14.8754 13.6721C16.2057 14.44 17.3106 15.5444 18.079 16.8744"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </a>
                </div>
                <div class="v-popper v-popper--theme-tooltip">
                    <a href="/personal/orders/basket" class="header__icon cart-icon">
                        <svg class="svg-icon" width="19" height="16" viewBox="0 0 19 16" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.8155 14.875H3.18435C3.03054 14.875 2.88214 14.8183 2.76753 14.7157C2.65292 14.6131 2.58016 14.4719 2.56318 14.319L1.45206 4.31902C1.44236 4.23166 1.45119 4.14323 1.47798 4.05951C1.50477 3.9758 1.54892 3.89867 1.60754 3.83317C1.66616 3.76768 1.73794 3.71528 1.81818 3.67941C1.89843 3.64354 1.98534 3.625 2.07324 3.625H16.9267C17.0146 3.625 17.1015 3.64354 17.1817 3.67941C17.262 3.71528 17.3337 3.76768 17.3924 3.83317C17.451 3.89867 17.4951 3.9758 17.5219 4.05951C17.5487 4.14323 17.5575 4.23166 17.5478 4.31902L16.4367 14.319C16.4197 14.4719 16.347 14.6131 16.2324 14.7157C16.1178 14.8183 15.9694 14.875 15.8155 14.875Z"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path
                                d="M6.375 6.125V3.625C6.375 2.7962 6.70424 2.00134 7.29029 1.41529C7.87634 0.82924 8.6712 0.5 9.5 0.5C10.3288 0.5 11.1237 0.82924 11.7097 1.41529C12.2958 2.00134 12.625 2.7962 12.625 3.625V6.125"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>

                        <div class="header-icon__num basket-count">{{ basket }}</div>
                    </a>
                </div>
            </div>
        </div>
        <div class="header__bottom container foldable" :class="slideUp ? 'header__bottom_folded':''">
            <nav v-if="menus" @scroll="handleScroll"
                 class="header__bottom-nav header__bottom-nav_blur header__bottom-nav_left-blur header__bottom-nav_right-blur header__bottom-nav_right-blur-active">
                <button type="button" class="slider-control slider-control_action_prev"> prev </button>
                <swiper
                    class="swiper-wrapper list bottom-nav-list "
                    :modules="modules"
                    :slides-per-view="5"
                    :space-between="30"
                    :mousewheel="true"
                    :navigation="{nextEl:'.slider-control_action_next',prevEl:'.slider-control_action_prev'}"
                >
                    <swiper-slide v-for="(menu, index) in menus.filter((item) => item.visible)" :key="menu.id" style="transform: translate3d(0px, 0px, 0px)">
                        <li class="bottom-nav-list__element">
                            <a @click.native="scrollToTop"
                               :href="`/catalog/${gender}/${menu.link}`"
                               :key="menu.id"
                               :class="['bottom-nav-list__link', {'router-link-active': index === 0  }]">{{ menu.category_name }}</a>
                        </li>
                    </swiper-slide>
                </swiper>
                <button type="button" class="slider-control slider-control_action_next">
                    next
                </button>
            </nav>
            <form class="header-search" action="/search">
                <div class="header-search__input-wrapper">
                    <input v-model="search" type="text" name="search" :placeholder="this.trans('Search')"
                           class="input-element header-search__input">
                </div>
                <div class="header-search__btn-wrapper">
                    <input class="input-element header-search__input-send" type="submit"
                           id="searchCards"></div>
            </form>
            <div class="header__control-row">
                <div class="v-popper v-popper--theme-tooltip">
                    <div class="select-region__">
                        <a href="#" class="header__icon header__icon__panel 123"
                           v-on:click="visible_country=!visible_country">
                            <svg class="svg-icon" width="25" height="25" viewBox="0 0 16 16" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <circle cx="8" cy="8" r="7.25" stroke="#000" stroke-width="0.6"></circle>
                                <path
                                    d="M8 15.25C7.7649 15.25 7.48181 15.1442 7.15894 14.8321C6.83246 14.5165 6.50419 14.0235 6.21224 13.3562C5.62932 12.0239 5.25 10.1307 5.25 8C5.25 5.86928 5.62932 3.97615 6.21224 2.64376C6.50419 1.97645 6.83246 1.48352 7.15894 1.16789C7.48181 0.855751 7.7649 0.75 8 0.75C8.2351 0.75 8.51819 0.855751 8.84106 1.16789C9.16754 1.48352 9.49581 1.97645 9.78776 2.64376C10.3707 3.97615 10.75 5.86928 10.75 8C10.75 10.1307 10.3707 12.0239 9.78776 13.3562C9.49581 14.0235 9.16754 14.5165 8.84106 14.8321C8.51819 15.1442 8.2351 15.25 8 15.25Z"
                                    stroke="#000" stroke-width="0.6"></path>
                                <line x1="1" y1="5.75" x2="15" y2="5.75" stroke="#000" stroke-width="0.6"></line>
                                <line x1="1" y1="10.25" x2="15" y2="10.25" stroke="#000" stroke-width="0.6"></line>
                            </svg>
                        </a>
                        <div class="select-region-js " v-show="visible_country">
                            <Globe/>
                        </div>
                    </div>
                </div>
                <div class="v-popper v-popper--theme-tooltip">
                    <a href="/personal/favourites" class="header__icon">
                        <svg class="svg-icon" width="19" height="16" viewBox="0 0 19 16" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.94194 14.5533L16.2726 8.22267C17.8281 6.66717 18.0576 4.10814 16.5855 2.47343C16.2168 2.06277 15.7683 1.73155 15.2673 1.49997C14.7664 1.26839 14.2235 1.1413 13.6718 1.12647C13.1201 1.11163 12.5712 1.20936 12.0585 1.41368C11.5458 1.618 11.0801 1.92464 10.6899 2.31488L9.5 3.50476L8.47267 2.47742C6.91717 0.921917 4.35814 0.692428 2.72343 2.16446C2.31277 2.53318 1.98155 2.9817 1.74997 3.48266C1.51839 3.98362 1.3913 4.52651 1.37647 5.0782C1.36163 5.6299 1.45936 6.17883 1.66368 6.69151C1.868 7.20419 2.17464 7.66987 2.56488 8.06012L9.05806 14.5533C9.17527 14.6705 9.33424 14.7364 9.5 14.7364C9.66576 14.7364 9.82473 14.6705 9.94194 14.5533V14.5533Z"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                        <div class="header-icon__num favourites-count">{{ favourites }}</div>
                    </a>
                </div>
                <div class="v-popper v-popper--theme-tooltip">
                    <a href="/personal" class="header__icon">
                        <svg class="svg-icon" width="21" height="20" viewBox="0 0 21 20" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10.5 12.5C13.2614 12.5 15.5 10.2614 15.5 7.5C15.5 4.73858 13.2614 2.5 10.5 2.5C7.73858 2.5 5.5 4.73858 5.5 7.5C5.5 10.2614 7.73858 12.5 10.5 12.5Z"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path
                                d="M2.9209 16.8743C3.6893 15.5442 4.79419 14.4398 6.12456 13.672C7.45493 12.9042 8.96393 12.5 10.5 12.5C12.036 12.5 13.545 12.9043 14.8754 13.6721C16.2057 14.44 17.3106 15.5444 18.079 16.8744"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </a>
                </div>
                <div class="v-popper v-popper--theme-tooltip">
                    <a href="/personal/orders/basket" class="header__icon cart-icon">
                        <svg class="svg-icon" width="19" height="16" viewBox="0 0 19 16" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.8155 14.875H3.18435C3.03054 14.875 2.88214 14.8183 2.76753 14.7157C2.65292 14.6131 2.58016 14.4719 2.56318 14.319L1.45206 4.31902C1.44236 4.23166 1.45119 4.14323 1.47798 4.05951C1.50477 3.9758 1.54892 3.89867 1.60754 3.83317C1.66616 3.76768 1.73794 3.71528 1.81818 3.67941C1.89843 3.64354 1.98534 3.625 2.07324 3.625H16.9267C17.0146 3.625 17.1015 3.64354 17.1817 3.67941C17.262 3.71528 17.3337 3.76768 17.3924 3.83317C17.451 3.89867 17.4951 3.9758 17.5219 4.05951C17.5487 4.14323 17.5575 4.23166 17.5478 4.31902L16.4367 14.319C16.4197 14.4719 16.347 14.6131 16.2324 14.7157C16.1178 14.8183 15.9694 14.875 15.8155 14.875Z"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path
                                d="M6.375 6.125V3.625C6.375 2.7962 6.70424 2.00134 7.29029 1.41529C7.87634 0.82924 8.6712 0.5 9.5 0.5C10.3288 0.5 11.1237 0.82924 11.7097 1.41529C12.2958 2.00134 12.625 2.7962 12.625 3.625V6.125"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                        <div class="header-icon__num basket-count">{{ basket }}</div>
                    </a>
                </div>
            </div>
        </div>
    </header>
    <notifications/>
</template>

<script>
import {Mousewheel,Navigation} from 'swiper/modules';

import {Swiper, SwiperSlide} from 'swiper/vue';
import Globe from './Globe.vue'
import 'swiper/css';
import 'swiper/css/pagination';
import MobilMenu from "./MobilMenu.vue";
import { addToCart, removeFromCart } from '../services/ga4Ecommerce.js';

export default {
    props: {
        menus: Object,
        gender: String,
        lang_file: Object,
        settings: Object,
    },
    name: "Menus",
    components: {
        Swiper,
        SwiperSlide,
        Globe,
        MobilMenu
    },
    data() {
        return {
            visible_country: false,
            countries: null,
            male: this.$store.state.settings.gender,
            modules: [Mousewheel,Navigation],
            inputSearch: "",
            favourites: 0,
            basket: 0,
            viewed: [],
            top_panel: '',
            search: '',
            airSelectLocation: false,
            selectLocationCountry: false,
            slideUp: false,
            slideUpBanner: false,
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.onViewportChange);
        if (this._headerResizeObserver) {
            this._headerResizeObserver.disconnect();
            this._headerResizeObserver = null;
        }
    },
    created() {
        this.$store.state.settings = this.settings
        this.$store.state.settings.promo = this.getStoredPromo()
    },
    computed: {
        maleCatalogPath() {
            return (this.$store.state.settings.protected_page) ? import.meta.env.VITE_MALE_CATALOG_PATH : '/catalog/male';
        },
        femaleCatalogPath() {
            return (this.$store.state.settings.protected_page) ? import.meta.env.VITE_FEMALE_CATALOG_PATH : '/catalog/female';
        },
        isTopMenuView() {
            return !this.$store.state.settings.protected_page
        },
        showSaleBanner() {
            if (this.$store.state.settings.site_id != 1) return false
            const path = window.location.pathname.replace(/\/+$/, '') || '/'
            return [
                '/catalog/male/bigsale',
                '/catalog/female/bigsale',
                '/stores',
            ].includes(path)
        },
        hasSecretInUrl() {
            return window.location.href.includes('secret')
        }
    },
    watch: {
        slideUp() {
            this.$nextTick(() => this.updateHeaderOffset())
        },
        slideUpBanner() {
            this.$nextTick(() => this.updateHeaderOffset())
        },
        top_panel() {
            this.$nextTick(() => this.updateHeaderOffset())
        },
        showSaleBanner() {
            this.$nextTick(() => this.updateHeaderOffset())
        },
    },
    mounted() {
        this.getTopPanel()
        this.updateParamUser()
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.onViewportChange);
        this.$nextTick(() => {
            this.updateHeaderOffset()
            const header = document.getElementById('header')
            if (header && typeof ResizeObserver !== 'undefined') {
                this._headerResizeObserver = new ResizeObserver(() => this.updateHeaderOffset())
                this._headerResizeObserver.observe(header)
            }
        })
    },
    methods: {

        getTopPanel() {
            this.top_panel = this.$store.state.settings.panels;
        },
        onViewportChange() {
            this.handleScroll()
            this.updateHeaderOffset()
        },
        updateHeaderOffset() {
            const header = document.getElementById('header')
            if (!header) return
            document.documentElement.style.setProperty(
                '--app-header-offset',
                `${header.offsetHeight}px`
            )
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        handleScroll() {
            const landscapeCompact = window.matchMedia('(orientation: landscape) and (max-height: 500px)').matches
            if (landscapeCompact) {
                this.slideUpBanner = window.scrollY > 20
            } else {
                this.slideUpBanner = false
            }

            if (window.innerWidth > 480) {
                this.slideUp = window.scrollY > 50
            } else {
                this.slideUp = false
            }
        },
        searchCards() {
            this.$refs.mob.searchCards(this.search)
            this.search = ''
        },
        toObjectCard(card, status) {
            return {
                status: status,
                guest_id: this.$store.state.settings.guest.id,
                user_id: this.$store.state.settings.user?.id,
                site_id: this.$store.state.settings.site_id,
                card_id: card.id,
                menu_id: card.menu_id,
                offer_id: card.offer.id,
                size_id: card.offer?.size.id,
                gender: card.gender,
                gender_id: card.gender_id,
                discount_id: card.discount_id ?? null,
                count: 1,
                category_link: card.category_link,
            }
        },
        updateParamUser() {
            this.favourites = this.$store.state.settings.basket.favourites.length
            this.basket = this.$store.state.settings.basket.basket.length
            this.viewed = this.$store.state.settings.basket.viewed
        },
        deleteBasket(card, index) {
            removeFromCart(card)
            this.$store.commit('removeFromBasket', index);
            this.updateParamUser()
            this.updateBasket()
        },
        createBasket(card) {
            addToCart(card)
            this.$store.commit('addToBasket', this.toObjectCard(card, 2))
            this.updateParamUser()
            this.updateBasket()
        },
        cardExistInWish(card) {
            if (this.$store.state.settings.basket.favourites.find(item => item.card_id === card.id)) {
                return true
            }
            return false
        },
        cardDeleteFromWish(card) {
            this.$store.state.settings.basket.favourites = this.$store.state.settings.basket.favourites.filter((item) => {
                    return item.card_id !== card.id
                })
        },
        cardAddToWish(card) {
            this.$store.state.settings.basket.favourites.push(this.toObjectCard(card, 1))
        },
        updateLike(card) {
            if (this.cardExistInWish(card)) {
                this.cardDeleteFromWish(card)
            } else {
                this.cardAddToWish(card)
            }
            // this.updateStorage(this.$store.state.settings)
            this.updateParamUser()
            this.updateBasket()
        },
        updateViewed(card) {
            if (this.$store.state.settings.basket.viewed.find(item => item.card_id === card.id)) {
            } else {
                this.$store.state.settings.basket.viewed.push(this.toObjectCard(card, 4))
                this.updateParamUser()
                this.updateBasket()
            }
        },
        updateBasket() {
            axios.post('/api/v1/update-basket', this.setParam({
                basket: this.$store.state.settings.basket,
                guest: this.$store.state.settings.guest.id,
            }))
                .then(data => {
                    this.$store.state.settings.basket = data.data;
                    this.updateParamUser();
                    this.updateStorage(this.$store.state.settings)
                })
        },
        showSecretLink() {
            if (this.hasSecretInUrl) {
                return false
            }
            if (this.$store.state.settings.site_id == 1 && this.$store.state.settings?.secret?.stage != 0) {
                return true
            } else if(this.$store.state.settings.site_id == 2 && this.$store.state.settings?.secret?.stage != 0) {
                return true
            }
            return false
        }
    }
}
</script>

<style scoped>
.router-link-active {
    color: red;
}

.header__center_folded, .header__top_folded, .header__sale-banner_folded {
    transition: .35s;
    height: 0 !important;
    opacity: 0 !important;
    overflow: hidden !important;
    margin: 0 !important;
    padding: 0 !important;
}

.header__center, .header__top, .header__sale-banner {
    transition: .35s;
    height: 100%;
    opacity: 1
}

.top-panel {
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
